

















































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';

const cssPrefix = 'user-selector';

@Component({
  components: {
    ...UUIFComponents,
    SwCheckbox,
  },
})

export default class UserSelector extends SwExtendedVue {
  @Prop()
  dataList: any;

  @Prop()
  label: string;

  @Prop()
  usedFor: string;

  @Prop()
  showCount: boolean;

  @Watch('selectedUser')
  onValueChange(val: any) {
    this.selectAll = ((this.dataList.length > 0) && (val.length === this.dataList.length)) ? true : false;
  }

  @Watch('dataList')
  onDataChange(val: any) {
    this.selectedUser = [];
    this.selectAll = ((val.length > 0) && (val.length === this.selectedUser.length)) ? true : false;
  }

  cssPrefix = cssPrefix;
  searchedItem: string = '';
  selectAll: boolean = false;
  selectedUser: any = [];

  get filteredUsers() {
    this.searchedItem = this.searchedItem.trim().toLowerCase();
    return this.dataList.filter((user: any) => {
      return user.emailAddress.toLowerCase().includes(this.searchedItem) || user.fullName.toLowerCase().includes(this.searchedItem);
    });
  }

  toggleSelectAll() {
    this.selectedUser = this.selectAll ? [...this.dataList] : [];
    this.$emit('onSelectionChange', this.selectedUser);
  }

  onUserSelectionChange() {
    this.$emit('onSelectionChange', this.selectedUser);
  }
}
